const componentsComboboxSoftwareSelectorComboboxEn = {
  searchSoftwarePlaceholder: "Search software...",
};

export default componentsComboboxSoftwareSelectorComboboxEn;
